module.exports = __webpack_public_path__ + "img/problem_shower.258a0c37.svg";